require('./bootstrap');
require('./plugins');

window.flatpickr = require('flatpickr/dist/flatpickr.min')
window.Indonesian = require('flatpickr/dist/l10n/id.js').default.id;
window.moment = require('moment/moment');
window.Chart = require('chart.js/dist/chart');
window.monthSelectPlugin = require('flatpickr/dist/plugins/monthSelect/index');
window.select2 = require('select2/dist/js/select2.min');

import SimpleLightbox from "simplelightbox";
window.SimpleLightbox = SimpleLightbox;

import ClassicEditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor';
window.ClassicEditor = ClassicEditor;

// Instal FilePond
import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginFileValidateSize);
FilePond.registerPlugin(FilePondPluginImagePreview);

window.FilePond = FilePond;

// Install AlpineJS
import Alpine from "alpinejs";
import Mask from "@ryangjchandler/alpine-mask";
import Clipboard from "@ryangjchandler/alpine-clipboard"
import Tooltip from "@ryangjchandler/alpine-tooltip";

Alpine.plugin(Mask);
Alpine.plugin(Clipboard);
Alpine.plugin(Tooltip);

window.Alpine = Alpine;
window.Alpine.start();
